import React, { Component } from "react";

export class ProfileWorkView extends Component {
  render() {
    return (
      <div>
        <h1>Profile Page - Work</h1>
      </div>
    );
  }
}
export default ProfileWorkView;
